module.exports = __webpack_public_path__ + "img/QR.b1b34723.jpg";